export const messagesTabMeta = {
  id: "messages",
  label: "Tin nhắn LMS",
  shortLabel: "Msg",
};
